<template>
  <div class="merchandise">
    <back-home-btn></back-home-btn>

    <v-container>
      <template v-if="itemDetail">
        <v-row>
          <!-- 商品画像 -->
          <v-col cols="12" md="8">
            <v-carousel
              cycle
              interval="15000"
              show-arrows-on-hover
              hide-delimiters
              height="100%"
            >
              <v-carousel-item v-for="(image, index) in images" :key="index">
                <v-img :aspect-ratio="imageAspectRatio" contain :src="image" />
                <!-- <v-row class="fill-height" align="center" justify="center">
                </v-row> -->
              </v-carousel-item>
            </v-carousel>
          </v-col>

          <!-- 商品説明 -->
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card flat>
              <v-card-title class="text-h4 font-weight-bold">
                {{ itemDetail.display_name }}
              </v-card-title>
              <v-card-text>
                <pre class="text-body-1">{{ itemDetail.content }}</pre>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- カート操作 -->
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-card>
              <v-card-text>
                <!-- サイズ選択 -->
                <v-select
                  v-model="selectType"
                  :items="types"
                  item-text="display_name"
                  return-object
                  label="サイズ"
                  dense
                  outlined
                ></v-select>

                <!-- 価格表示 -->
                <p class="text-h5 font-weight-bold text-center">
                  {{ selectType.price | formatPrice }}
                </p>

                <!-- 数量選択 -->
                <v-row class="my-5">
                  <v-spacer></v-spacer>
                  <v-col cols="6">
                    <v-select
                      v-model="selectQty"
                      :items="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
                      dense
                      label="数量"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>

                <!-- カートに入れるボタン -->
                <v-btn
                  color="primary"
                  class="white--text"
                  rounded
                  block
                  large
                  :disabled="
                    selectType.id == 0 || Number(itemDetail.inventory) <= 0
                  "
                  @click="addInCart"
                >
                  <v-icon class="text-h5" left>mdi-cart-outline</v-icon>
                  <span v-if="Number(itemDetail.inventory) <= 0" class="text-h6"
                    >完売しました</span
                  >
                  <span v-else class="text-h6">カートに入れる</span>
                </v-btn>
              </v-card-text>

              <!-- カート追加時メッセージ -->
              <v-snackbar
                v-model="snackbar"
                :timeout="5000"
                bottom
                color="info"
                dark
              >
                商品をカートに追加しました。
                <template v-slot:action="{ attrs }">
                  <v-btn text v-bind="attrs" @click="snackbar = false">
                    閉じる
                  </v-btn>
                </template>
              </v-snackbar>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- スケルトンローダ -->
      <template v-else>
        <v-row class="mx-5">
          <!-- 商品画像のスケルトンローダ -->
          <v-col cols="12">
            <v-card>
              <v-skeleton-loader
                class="mx-auto"
                type="image"
              ></v-skeleton-loader>
            </v-card>
          </v-col>

          <!-- 商品説明のスケルトンローダ -->
          <v-col cols="12" class="pa-5">
            <v-skeleton-loader class="mb-5" type="heading"></v-skeleton-loader>
            <v-skeleton-loader
              class="mb-5"
              type="paragraph"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mb-5"
              type="paragraph"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BackHomeBtn from '../components/common/BackHomeBtn.vue';

// 商品タイプ初期表示用
const defaultTypeObject = {
  id: 0,
  name: '',
  display_name: '選択して下さい',
  price: 0,
};

export default {
  components: {
    BackHomeBtn,
  },
  data: () => ({
    selectType: defaultTypeObject,
    selectQty: 1,
    snackbar: false,
  }),
  computed: {
    ...mapGetters({
      // 認証ユーザー
      authUser: 'auth/authUser',
      findDetail: 'merchandise/findDetail',
    }),
    // 顧客の料金種別コード
    authUserPriceTypeId() {
      return this.authUser && this.authUser.customer_group
        ? this.authUser.customer_group.price_type_id
        : 0;
    },
    // 商品詳細
    itemDetail() {
      return this.findDetail(this.$route.query.id);
    },
    // 商品画像
    images() {
      const merchandiseId = Number(this.$route.query.id);
      let ar = [];
      ar.push(`/img/image${merchandiseId}1.jpg`);

      switch (merchandiseId) {
        // case 1:
        // case 4:
        case 2:
        case 5:
        case 6:
        case 7:
        case 8:
          // case 13:
          // case 14:
          // ar.push(`/img/b.jpg`);
          // ar.push(`/img/c.jpg`);
          break;
        default:
          break;
      }

      // 暫定対応
      switch (merchandiseId) {
        case 9:
        case 10:
        case 11:
        case 12:
          ar.push(`/img/image02N.jpg`);
          ar.push(`/img/image${merchandiseId}2.jpg`);
          ar.push(`/img/image${merchandiseId}M.jpg`);
          break;
        case 8:
          // セット
          ar.push(`/img/image81B.jpg`);
          ar.push(`/img/image22.jpg`);
          ar.push(`/img/image12.jpg`);
          ar.push(`/img/image62.jpg`);
          ar.push(`/img/image132.jpg`);
          break;
        default:
          ar.push(`/img/image${merchandiseId}2.jpg`);
          ar.push(`/img/${merchandiseId}M.jpg`);
          break;
      }

      // review
      switch (merchandiseId) {
        case 1:
        case 4:
        case 9:
        case 10:
          ar.push(`/img/RK.jpg`);
          break;
        case 2:
        case 5:
        case 11:
        case 12:
          ar.push(`/img/RM.jpg`);
          break;
        case 15:
        case 16:
          ar.push(`/img/RT.jpg`);
          break;
        default:
          break;
      }

      ar.push(`/img/W.jpg`);

      if (merchandiseId === 15 || merchandiseId === 16) {
        ar.push(`/img/image153.jpg`);
        ar.push(`/img/image154.jpg`);
        ar.push(`/img/image155.jpg`);
        ar.push(`/img/image156.jpg`);
        ar.push(`/img/image157.jpg`);
        ar.push(`/img/image158.jpg`);
        ar.push(`/img/image159.jpg`);

        return ar;
      }

      ar.push(`/img/image03.jpg`);
      ar.push(`/img/image04.jpg`);
      ar.push(`/img/image05.jpg`);
      ar.push(`/img/image06.jpg`);
      ar.push(`/img/image07.jpg`);
      // ar.push(`/img/image08.jpg`);
      // ar.push(`/img/image09.jpg`);
      return ar;
    },
    // 商品種別
    types() {
      let ar = [];
      ar.push(defaultTypeObject);
      this.itemDetail.types.forEach(type => {
        type.display_name =
          type.name + (type.price_type_id != 0 ? ' (特別価格商品)' : '');
        ar.push(type);
      });
      return ar.sort((a, b) => {
        if (a.price_type_id !== b.price_type_id) {
          // -1 かけて降順にする
          return (a.price_type_id - b.price_type_id) * -1;
        }

        if (a.weight !== b.weight) {
          return Number(a.weight) - Number(b.weight);
        }
        return 0;
      });
    },
    imageAspectRatio() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 0;
        default:
          return 16 / 9;
      }
    },
  },
  methods: {
    // 商品詳細取得
    getMerchandiseInfo() {
      const id = this.$route.query.id;
      const priceTypeId = this.authUserPriceTypeId;

      this.$store.dispatch('merchandise/loadItemDetailByKey', {
        id,
        priceTypeId,
      });
    },
    // カートに追加
    async addInCart() {
      if (this.selectType.id == 0) return;

      await this.$store.dispatch('cart/addItem', {
        merchandiseId: this.itemDetail.id,
        priceTypeId: this.selectType.price_type_id,
        size: this.selectType.size,
        packingId: 0,
        price: Number(this.selectType.price),
        qty: this.selectQty,
        amount: Number(this.selectType.price) * this.selectQty,
        merchandiseName: this.itemDetail.display_name,
        typeName: this.selectType.name,
        image: this.itemDetail.image_url_1,
      });
      this.snackbar = true;
    },
  },
  filters: {
    // 価格表示
    formatPrice(val) {
      return `￥ ${Number(val).toLocaleString()}（税込）`;
    },
  },
  created() {
    if (!this.itemDetail) {
      this.getMerchandiseInfo();
    }
  },
  watch: {
    authUser: function() {
      this.getMerchandiseInfo();
    },
  },
};
</script>

<style scoped>
pre {
  white-space: pre-wrap;
}
</style>
